<script setup lang="ts">

import KeyFob from "../Icons/KeyFob.vue";
import Brakes from "../Icons/Brakes.vue";
import WiperBlades from "../Icons/WiperBlades.vue";
import Battery from "../Icons/Battery.vue";
import Tyres from "../Icons/Tyres.vue";
import Concierge from "../Icons/Concierge.vue";

</script>

<template>

    <div class="max-w-5xl mx-auto px-8">
        <div class="tracking-wider pt-48 pb-16 lg:-mx-5 xl:-mx-16">
            <div class="rounded-3xl bg-gray-50 pr-4">

                <div class="flex justify-center z-10 mb-12">
                    <div class="flex justify-center z-10">
                        <video ref="video"
                            width="80%" 
                            autoplay 
                            controls 
                            class="-mt-56 mb-8 rounded-lg shadow-lg ring ring-black"
                            onloadstart="this.volume=0.3">
                            <source src="/video/protect.mp4" type="video/mp4" />
                            <!-- <img src="@/assets/images/Screenshots/screenshot-app-hero-angled.png" class="w-2/3 md:w-1/2 -mt-64 scale-90"/> -->
                        </video> 
                    </div>
                </div>
                
                <h1 class="text-4xl font-semibold text-center mb-8">
                    Here's what's included
                </h1>

                <div class="flex gap-y-4 3xl:gap-y-6 flex-wrap justify-center pb-6">

                    <!-- KEY FOB -->
                    <div class="basis-full md:basis-1/3 flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <KeyFob class="w-16 mx-auto md:mx-0 text-[#B5424A]"/>
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            Key Fob Repair
                        </h2>    
                        <p class="text-center">
                            Refresh or repair components of your key fobs to keep them working reliably
                        </p>                
                    </div>

                    <!-- WIPER BLADES -->
                    <div class="basis-full md:basis-1/2 lg:basis-1/3 flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <WiperBlades class="w-16 mx-auto md:mx-0 text-[#B5424A]"/>
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            Wiper Blades
                        </h2>    
                        <p class="text-center">
                            Replace worn-out wiper-blades for a clear view
                        </p>                
                    </div>

                    <!-- BATTERY -->
                    <div class="basis-full md:basis-1/2 lg:basis-1/3 flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <Battery class="w-16 mx-auto md:mx-0 text-[#B5424A]"/>
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            12-volt Battery
                        </h2>    
                        <p class="text-center">
                            Get your 12-volt battery replaced when it fails due to normal wear and tear
                        </p>                
                    </div>

                    <!-- TYRE REPAIR / REPLACEMENT -->
                    <div class="basis-full md:basis-1/2 lg:basis-1/3 flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <Tyres class="w-16 mx-auto md:mx-0 text-[#B5424A]" />
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            Tyre Safety
                        </h2>    
                        <p class="text-center">
                            Repair or replace worn out tyres, or damaged tyres caused by road hazards
                        </p>                
                    </div>

                    <!-- BRAKES SERVICE -->
                    <div class="basis-full md:basis-1/3 flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <Brakes class="w-16 mx-auto md:mx-0 text-[#B5424A]"/>
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            Brake Safety
                        </h2>    
                        <p class="text-center">
                            Replace worn brake pads, rotors, or drums for optimal stopping power
                        </p>                
                    </div>

                    <!-- CONCIERGE -->
                    <div class="basis-full md:basis-1/3 flex flex-col items-center p-6 md:p-8 lg:p-12">
                        <Concierge class="w-16 mx-auto md:mx-0 mt-2 text-[#B5424A]"/>
                        <h2 class="text-2xl font-semibold my-4 text-center">
                            Concierge Service
                        </h2>    
                        <p class="text-center">
                            One-call assistance for claims, service bookings, and support-helping you get back on the road faster
                        </p>                
                    </div>

                </div>

            </div>

        </div>
    </div>

</template>